<template>
    <kgr-generic-select
        ref="dropdown"
        display="fullName"
        :label="label"
        :options="relationMembers"
        :loading="loading"
        :inline="inline"
        @post-input="onInput"
    />
</template>

<script>
import DogRepository from '../../../../js/repository/DogRepository.js';
import GenericSelect from './GenericSelect.vue';

export default {
    components: {
        'kgr-generic-select': GenericSelect,
    },
    props: {
        dogId: {
            type: String,
            required: true,
        },
        hideLabel: {
            type: Boolean,
            required: false,
            default: false,
        },
        inline: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            loading: true,
            relations: [],
        }
    },
    computed: {
        label() {
            return this.hideLabel ? null : this.$t('club.dogMemberRelations');
        },
        relationMembers() {
            return this.relations.map((relation) => relation.member);
        }
    },
    created() {
        this.reload();
    },
    methods: {
        reload() {
            DogRepository
                .findMemberRelations(this.dogId)
                .then(data => {
                    this.loading = false;
                    this.relations = data;
                })
                .catch(() => this.$notify.error('error.loadingData'));
        },
        onInput(value) {
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        }
    }
}
</script>
